
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsPromoBanner',
})
export default class CmgRewardsPromoBanner extends Vue {
  interval: any;
  currentIndex = 0;

  mounted() {
    this.cycleThroughTextAndImages();
    this.interval = setInterval(this.cycleThroughTextAndImages, 3500);
  }

  destroyed() {
    clearInterval(this.interval);
  }

  get imageRefs(): Element[] {
    return [ this.$refs.guacImage, this.$refs.burritoImage, this.$refs.drinkImage, this.$refs.goodsImage, this.$refs.givingImage ] as Element[];
  }

  get textRefs(): Element[] {
    return [ this.$refs.guacText, this.$refs.burritoText, this.$refs.drinkText, this.$refs.goodsText, this.$refs.givingText ] as Element[];
  }

  get rewardPepperUrl(): string {
    return this.$appStore.state.cms.images.logos.rewardPepper.default;
  }

  get rewardArrowUrl(): string {
    return this.$appStore.state.cms.images.icons.rewardArrow.default;
  }

  get burstUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.burst.default;
  }

  get guacUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.guac.default;
  }

  get guacSrcSet(): string {
    const guac500 = this.$appStore.state.cms.images.promoBanners.guac500.default;
    const guac800 = this.$appStore.state.cms.images.promoBanners.guac800.default;
    const guac1080 = this.$appStore.state.cms.images.promoBanners.guac1080.default;
    
    return `${guac500} 500w, ${guac800} 800w, ${guac1080} 1080w, ${this.guacUrl} 1356w`
  }
  
  get burritoUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.burrito.default;
  }
  
  get burritoSrcSet(): string {
    const burrito500 = this.$appStore.state.cms.images.promoBanners.burrito500.default;
    const burrito800 = this.$appStore.state.cms.images.promoBanners.burrito800.default;
    const burrito1080 = this.$appStore.state.cms.images.promoBanners.burrito1080.default;

    return `${burrito500} 500w, ${burrito800} 800w, ${burrito1080} 1080w, ${this.burritoUrl} 1326w`;
  }

  get drinkUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.drink.default;
  }

  get drinkSrcSet(): string {
    const drink500 = this.$appStore.state.cms.images.promoBanners.drink500.default;

    return `${drink500} 500w, ${this.drinkUrl} 800w`;
  }

  get goodsUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.goods.default;
  }

  get goodsSrcSet(): string {
    const goods500 = this.$appStore.state.cms.images.promoBanners.goods500.default;
    const goods800 = this.$appStore.state.cms.images.promoBanners.goods800.default;
    
    return `${goods500} 500w, ${goods800} 800w, ${this.goodsUrl} 1000w`;
  }

  get givingUrl(): string {
    return this.$appStore.state.cms.images.promoBanners.giving.default;
  }

  get givingSrcSet(): string {
    const giving500 = this.$appStore.state.cms.images.promoBanners.giving500.default;

    return `${giving500} 500w, ${this.givingUrl} 800w`;
  }
  
  addClasses(elements: Element[], className: string) {
    elements.forEach((element: Element) => element.classList.add(className));
  }

  removeClasses(elements: Element[]) {
    elements.forEach((element: Element) => element.classList.remove('enter'));
    elements.forEach((element: Element) => element.classList.remove('leave'));
  }

  onClickJoinNow() {
    const enrollmentOptions: EnrollmentOptions = { customer: this.$appStore.state.customer.profile, pageTitle: document.title };
    this.$services.loyalty.enrollInLoyalty(enrollmentOptions)
      .catch(e => this.$services.logger.error('Something went wrong enrolling in loyalty', undefined, e));
  }

  cycleThroughTextAndImages() {
    const currentText = this.textRefs[this.currentIndex] as Element;
    const currentImage = this.imageRefs[this.currentIndex] as Element;
    const currentElements = [ currentText, currentImage ];

    this.addClasses(currentElements, 'enter');
    
    setTimeout(() => {
      this.addClasses(currentElements, 'leave');
    }, 2500);

    setTimeout(() => {
      this.removeClasses(currentElements);

      this.currentIndex++;
      this.currentIndex %= 5;
    }, 3000);
  }
}
